import * as Vuex from "vuex";
import enums from '../utils/enums'
import api from '../api/index'
import CONST_VAR from "../utils/const_var";
import resource from "../assets/data/resource";

const store = Vuex.createStore({
  state: {
    bodyHeight: document.body.clientHeight,
    bodyWidth: document.body.clientWidth,
    maskDialog: false,
    maskDialogMode: 'dark',
    version: '17.1.0',
    userinfo: {
      school: {
        name: '中央戏剧学院',
        department: null,
        joinTime: null,
        education: null,
        displayType: enums.DISPLAY_TYPE.ALL,
      },
    },
    friends: resource.users,
    excludeRoutes: [],
    judgeValue: 20,
    homeRefresh: 60,
    loading: false,
  },
  mutations: {
    setLoading(store, val) {
      store.loading = val
    },
    setUserinfo(store, val) {
      store.userinfo = val
    },
    setFriends(store, val) {
      store.friends = val
    },
    setMaskDialog(store, val) {
      store.maskDialog = val.state
      if (val.mode) {
        store.maskDialogMode = val.mode
      }
    },
    updateExcludeRoutes(store, val) {
      if (val.type === 'add') {
        if (!store.excludeRoutes.find(v => v === val.value)) {
          store.excludeRoutes.push(val.value)
        }
      } else {
        let resIndex = store.excludeRoutes.findIndex(v => v === val.value)
        if (resIndex !== -1) {
          store.excludeRoutes.splice(resIndex, 1)
        }
      }
      // console.log('store.excludeRoutes', store.excludeRoutes)
    },
  },
  actions: {
    async getFriends(context) {
      let res = await api.user.friends()
      if (res.code === CONST_VAR.SUCCESS) {
        context.commit('setFriends', res.data)
      }
    }
  }
})

export default store